import { render, staticRenderFns } from "./NewParticipant.vue?vue&type=template&id=dedc597a&"
import script from "./NewParticipant.vue?vue&type=script&lang=js&"
export * from "./NewParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports